import { supabase } from '@/src/lib/supabase';

export interface VenuePerson { id: string; name: string | null; app_role: string; position: string | null }

/**
 * Everyone with an OpsAlo login at the venue that's open, with their role THERE.
 * Includes people who work at several venues and currently have another one open
 * (users.venue_id is only the venue someone last opened). Falls back to the old query
 * if the database update (20261101020000_multi_venue_people.sql) isn't in yet.
 */
export async function venuePeople(venueId: string): Promise<VenuePerson[]> {
  const r = await supabase.rpc('venue_people');
  if (!r.error && Array.isArray(r.data)) return r.data as VenuePerson[];
  let f = await supabase.from('users').select('id, name, app_role, position').eq('venue_id', venueId).neq('active', false).not('auth_user_id', 'is', null).order('name');
  if (f.error) f = await supabase.from('users').select('id, name, app_role').eq('venue_id', venueId).neq('active', false).not('auth_user_id', 'is', null).order('name') as typeof f;
  return ((f.data ?? []) as Array<Omit<VenuePerson, 'position'> & { position?: string | null }>).map((p) => ({ ...p, position: p.position ?? null }));
}
